module.exports = __webpack_public_path__ + "static/media/Contact1.2109e872.jpg";